import * as React from 'react'
import { Col } from 'react-bootstrap';
import moment from "moment"
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

const modifiers = {
    highlighted: new Date(2018, 8, 19),
};

export interface ICalendarPickerProps {
    moveDate: string
    onChangeInputs(key: string, value: any): void
}

const CalendarPicker: React.FC<ICalendarPickerProps> = ({ moveDate, onChangeInputs }) => {
    const [currentDate, setCurrentDate] = React.useState<Date | undefined>()

    React.useEffect(() => {
        if (moveDate != null || moveDate != undefined) {         
            setCurrentDate(moment(moveDate).toDate())
        }
    }, [moveDate])

    const handleDayClick = (day: Date | undefined, modifier) => {
        setCurrentDate(day)
        onChangeInputs("moveDate", moment(day).format("YYYY-MM-DD HH:mm:ss"))
    }

    return (
        <div className="text-center">
            <h3 >Move Date</h3>
            <Col>
                <DayPicker
                    selectedDays={currentDate}
                    onDayClick={handleDayClick}
                    modifiers={modifiers}
                    month={new Date()} />

            </Col>
        </div>
    );
}

export { CalendarPicker };